import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header block" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "container block block-alone" }
const _hoisted_5 = { class: "table" }
const _hoisted_6 = { class: "flex gap-16" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "point" }
const _hoisted_9 = { class: "drawer-contain" }
const _hoisted_10 = { class: "drawer-header" }
const _hoisted_11 = { class: "drawer-header-lt" }
const _hoisted_12 = { class: "drawer-lt-title" }
const _hoisted_13 = { class: "drawer-header-rt" }
const _hoisted_14 = { class: "drawer-desc" }
const _hoisted_15 = { class: "descriptions" }
const _hoisted_16 = {
  class: /*@__PURE__*/_normalizeClass(['cell-item'])
}
const _hoisted_17 = {
  key: 0,
  class: "cell-item-text"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { key: 4 }
const _hoisted_24 = { key: 5 }
const _hoisted_25 = { key: 6 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 4 }
const _hoisted_28 = { key: 5 }
const _hoisted_29 = { key: 6 }
const _hoisted_30 = { key: 7 }
const _hoisted_31 = ["href"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 8,
  class: "files-cell"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "time-line" }
const _hoisted_36 = { class: "process-timeline" }
const _hoisted_37 = { class: "timeline-item-i" }
const _hoisted_38 = { class: "i-title" }
const _hoisted_39 = { class: "i-time" }
const _hoisted_40 = { class: "timeline-item-remark" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_batchPayroll = _resolveComponent("batchPayroll")!
  const _component_Back = _resolveComponent("Back")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "请输入出险姓名或身份证",
            class: "input search-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.searchText]
          ]),
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, "搜索"),
          _createElementVNode("button", {
            class: "btn-white",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
          }, "重置")
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onAdd && _ctx.onAdd(...args)))
          }, "新增理赔 ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_tabs, { "model-value": "detail" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_table, {
              data: _ctx.tableData,
              style: {"width":"100%"},
              "header-row-style": { color: '#202536' },
              "row-style": { color: '#5E617D' },
              onSelectionChange: _ctx.handleSelectionChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "outDangerUserName",
                  label: "出险人"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", {
                        style: {"color":"#1989FA"},
                        class: "point",
                        onClick: ($event: any) => (_ctx.onClickName(scope.row))
                      }, _toDisplayString(scope.row.outDangerUserName), 9, _hoisted_7)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "身份证",
                  prop: "outDangerIdCardNo"
                }),
                _createVNode(_component_el_table_column, {
                  label: "保险商品",
                  prop: "companyPlanName"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "outDangerDate",
                  label: "出险时间"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "outDangerPlace",
                  label: "出险地点"
                }),
                _createVNode(_component_el_table_column, { label: "状态" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(scope.row.reportStatus === 1 || scope.row.reportStatus === 5 ? '处理中' :
                                            scope.row.reportStatus === 2 || scope.row.reportStatus === 6 ? '已结案' :
                                                scope.row.reportStatus === 3 ? '已驳回' : scope.row.reportStatus === 4 ? '已撤销' : '待处理'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "createTime",
                  label: "报案时间"
                })
              ]),
              _: 1
            }, 8, ["data", "onSelectionChange"]),
            _createVNode(_component_el_pagination, {
              class: "pagination",
              currentPage: _ctx.pageNum,
              "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pageNum) = $event)),
              "page-size": _ctx.pageSize,
              "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageSize) = $event)),
              "page-sizes": [10, 30, 50, 100],
              layout: "total, sizes, prev, pager, next, jumper",
              total: _ctx.total,
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.getPayrollList
            }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
          ])
        ]),
        _: 1
      }),
      (_ctx.isBatchPay)
        ? (_openBlock(), _createBlock(_component_batchPayroll, {
            key: 0,
            onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isBatchPay = false)),
            onComplete: _ctx.getPayrollList,
            isType: "payroll"
          }, null, 8, ["onComplete"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showDrawer,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.showDrawer) = $event)),
      size: "70%",
      "with-header": false,
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[11] || (_cache[11] = _createTextVNode(" 报案信息 ")),
                _createElementVNode("text", {
                  class: _normalizeClass(['drawer-lt-title-status', `title-status${_ctx.staffBaseInfo.reportStatus}`])
                }, _toDisplayString(_ctx.formatter(_ctx.staffBaseInfo.reportStatus, _ctx.reportStatusList, { valueKey: 'value' })), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_button, {
                size: "small",
                onClick: _ctx.goBack
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Back)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_descriptions, {
                class: "margin-top",
                column: 2,
                size: "default",
                border: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staffColumnItem, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_descriptions_item, {
                      key: index,
                      span: item.span || 1
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(item.label), 1)
                      ]),
                      default: _withCtx(() => [
                        (item.showType == 'normal')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.emptyText(_ctx.staffBaseInfo[item.field])), 1))
                          : _createCommentVNode("", true),
                        (item.showType == 'option')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              (item.field == 'accidentType')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.emptyText(_ctx.formatter(_ctx.staffBaseInfo[item.field], _ctx.accidentTypeList, { valueKey: 'value' }))), 1))
                                : _createCommentVNode("", true),
                              (item.field == 'hospitalStatus')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.emptyText(_ctx.formatter(_ctx.staffBaseInfo[item.field], _ctx.flagList, { valueKey: 'value' }))), 1))
                                : _createCommentVNode("", true),
                              (item.field == 'hurtStatus')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.emptyText(_ctx.formatter(_ctx.staffBaseInfo[item.field], _ctx.superHurtTypeList, { valueKey: 'value' }))), 1))
                                : _createCommentVNode("", true),
                              (item.field == 'surgeryStatus')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.emptyText(_ctx.formatter(_ctx.staffBaseInfo[item.field], _ctx.flagList, { valueKey: 'value' }))), 1))
                                : _createCommentVNode("", true),
                              (item.field == 'accidentStatus')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.emptyText(_ctx.formatter(_ctx.staffBaseInfo[item.field], _ctx.accidentStatusList, { valueKey: 'value' }))), 1))
                                : _createCommentVNode("", true),
                              (item.field == 'treatmentMethod')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.emptyText(_ctx.formatter(_ctx.staffBaseInfo[item.field], _ctx.treatmentMethodList, { valueKey: 'value' }))), 1))
                                : _createCommentVNode("", true),
                              (item.field == 'accidentCause')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.emptyText(_ctx.formatter(_ctx.staffBaseInfo[item.field], _ctx.accidentCauseList, { valueKey: 'value' }))), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (item.showType == 'money')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.staffBaseInfo[item.field] || _ctx.staffBaseInfo[item.field] === 0 ? '￥' + _ctx.staffBaseInfo[item.field] : '--'), 1))
                          : _createCommentVNode("", true),
                        (item.showType == 'idCardNo')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 3,
                              style: {"cursor":"pointer"},
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onClickCardNo && _ctx.onClickCardNo(...args)))
                            }, _toDisplayString(_ctx.cardNumShow ? _ctx.staffBaseInfo.outDangerIdCardNo : _ctx.staffBaseInfo.cardNumber), 1))
                          : _createCommentVNode("", true),
                        (item.showType == 'childObj')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.emptyText(_ctx.userPlanInfo[item.field])), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (item.showType == 'occupation')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              (_ctx.userPlanInfo.occupationLevel)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 0,
                                    size: "small",
                                    class: "mg-r-5"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.userPlanInfo.occupationLevel) + "类", 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", null, _toDisplayString(_ctx.emptyText(_ctx.userPlanInfo.occupationName)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (item.showType == 'time')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.userPlanInfo.insureStartTime) + " - " + _toDisplayString(_ctx.checkInsureEndTime(_ctx.userPlanInfo.insureEndTime)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (item.showType == 'video')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              (_ctx.staffBaseInfo.fileUrl && _ctx.staffBaseInfo.fileUrl.length)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.staffBaseInfo.fileUrl, (itm, idx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "left-video",
                                      key: idx
                                    }, [
                                      _createElementVNode("a", {
                                        class: "left-video-a",
                                        target: "_blank",
                                        href: itm.fileUrl
                                      }, "点击查看", 8, _hoisted_31)
                                    ]))
                                  }), 128))
                                : (_openBlock(), _createElementBlock("span", _hoisted_32, "--"))
                            ]))
                          : _createCommentVNode("", true),
                        (item.showType == 'files')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _createElementVNode("span", {
                                class: "material-link",
                                onClick: ($event: any) => (_ctx.onPreviewFiles(item))
                              }, "点击查看(" + _toDisplayString(_ctx.getCaseFiles(item.type).length) + "/" + _toDisplayString(_ctx.fileLimit) + ")", 9, _hoisted_34),
                              (_ctx.getCaseFiles(item.type).length < _ctx.fileLimit)
                                ? (_openBlock(), _createBlock(_component_el_upload, {
                                    key: 0,
                                    action: _ctx.uploadAction,
                                    headers: { Authorization: _ctx.Authorization },
                                    "show-file-list": false,
                                    multiple: "",
                                    "before-upload": (file) => _ctx.onBeforeUpload(item, file),
                                    "on-success": (response) => _ctx.onUploadSuccess(item, response),
                                    "on-error": _ctx.onUploadError,
                                    accept: ".jpg,.jpeg,.png"
                                  }, {
                                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                                      _createElementVNode("span", { class: "material-link" }, "上传附件", -1)
                                    ])),
                                    _: 2
                                  }, 1032, ["action", "headers", "before-upload", "on-success", "on-error"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["span"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_35, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "time-line-title" }, "案件进展", -1)),
              (_ctx.processList.length === 0)
                ? (_openBlock(), _createBlock(_component_el_empty, {
                    key: 0,
                    description: "暂无进展"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_el_timeline, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processList, (activity, index) => {
                      return (_openBlock(), _createBlock(_component_el_timeline_item, {
                        key: index,
                        icon: activity.icon,
                        type: activity.type,
                        color: activity.color,
                        size: activity.size,
                        hollow: activity.hollow
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, _toDisplayString(activity.reportSolveResult), 1),
                            _createElementVNode("div", _hoisted_39, _toDisplayString(activity.timestamp), 1)
                          ]),
                          _createElementVNode("div", _hoisted_40, _toDisplayString(activity.remark), 1)
                        ]),
                        _: 2
                      }, 1032, ["icon", "type", "color", "size", "hollow"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.imageViewerVisible)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": _ctx.previewImages,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.imageViewerVisible = false))
        }, null, 8, ["url-list"]))
      : _createCommentVNode("", true)
  ]))
}